import { EyeIcon, EyeSlashIcon } from 'shared/ui/icons';
import { useTranslation } from 'react-i18next';
import useLoginPassword from '../../hooks/useLoginPassword';

const LoginPassword = ({ formData, setFormData, setLoginOtp }) => {
  const { t } = useTranslation('common');

  const {
    showPassword,
    loading,
    errors,
    handleChange,
    handleTogglePassword,
    handleLogin,
    handleKeyDown,
    navigateToForgotPassword,
  } = useLoginPassword({ formData, setFormData, setLoginOtp });

  return (
    <>
      <div className="w-full mt-5">
        <h1 className="font-semibold text-2xl">{t('login_to_sembuh_ai')}</h1>
      </div>
      <div className="w-full">
        <p className="text-base font-normal text-slate-500">
          {t('login_to_access_dashboard')}
        </p>
      </div>
      {errors?.error && (
        <div className="w-full rounded-lg py-3 px-4 bg-red-100 border-2 border-red-300 mt-6 text-[#B42318] font-medium text-sm text-start">
          {errors?.error}
        </div>
      )}
      <div className="w-full my-6">
        <div>
          <div className="mt-2">
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              placeholder={t('Email')}
              onChange={handleChange}
              value={formData?.email}
              className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-500 focus:outline-none sm:text-sm sm:leading-6"
            />
            {errors?.email && (
              <div className="w-full justify-start items-start flex">
                <span className="text-red-500 text-sm">{errors?.email}</span>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="w-full">
        <div className="my-0">
          <div className="mt-2 relative">
            <input
              id="password"
              name="password"
              type={showPassword ? 'text' : 'password'}
              autoComplete="current-password"
              placeholder={t('password')}
              value={formData?.password}
              onKeyDown={handleKeyDown}
              onChange={handleChange}
              className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-500 focus:outline-none sm:text-sm sm:leading-6"
            />
            <button
              type="button"
              onClick={handleTogglePassword}
              className={`absolute inset-y-0 right-3 flex items-center ${
                errors?.password ? 'pb-5' : 'pt-0'
              }`}
            >
              {showPassword ? <EyeIcon /> : <EyeSlashIcon />}
            </button>
            {errors?.password && (
              <div className="w-full justify-start items-start flex">
                <span className="text-red-500 text-sm">{errors?.password}</span>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="w-full my-3 flex justify-end">
        <button
          type="button"
          onClick={navigateToForgotPassword}
          className="text-sm font-semibold text-blue-600 cursor-pointer"
        >
          {t('forgot_password')}
        </button>
      </div>
      <div className="w-full flex flex-col justify-center text-center mt-3 gap-4">
        <button
          type="button"
          onClick={handleLogin}
          disabled={loading}
          className="flex w-full bg-blue-500 justify-center rounded-md bg-con-brand px-3 py-2 text-medium font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          {loading ? (
            <div className="animate-spin rounded-full h-5 w-5 border-t-2 mx-3 my-0.5 border-white border-solid m-auto" />
          ) : (
            t('login')
          )}
        </button>
      </div>
    </>
  );
};

export default LoginPassword;
